import { z } from "zod";
import type { DefaultValues } from "react-hook-form";

export const taxonomicGroupsSchema = z.object({
  rein: z.string().min(1, "Reino é obrigatório"),
  phylum: z.string().min(1, "Filo é obrigatório"),
  class: z.string().min(1, "Classe é obrigatória"),
  order: z.string().min(1, "Ordem é obrigatória"),
  family: z.string().optional(),
  genus: z.string().optional(),
  species: z.string().optional(),
});

export type TaxonomicGroupsFormData = z.infer<typeof taxonomicGroupsSchema>;

export const taxonomicGroupDefaultValues: DefaultValues<TaxonomicGroupsFormData> =
  {
    rein: "",
    phylum: "",
    class: "",
    order: "",
    family: "",
    genus: "",
    species: "",
  };
